export default __webpack_public_path__ + "static/media/tech-support-icon.aa177ab5.svg";